

<script setup>
import { inject, ref } from 'vue'
import { getIcon } from '@/tiptap/constants/icons.js'
import { actionButtonProps } from './props.js'

const props = defineProps(actionButtonProps)
const disableToolbar = inject('disableToolbar', ref(false))
</script>

<script>
export default {
  name: 'ActionButtonBase',
}
</script>

<template>
  <VBtn
    class="rounded me-1 ms-0"
    density="comfortable"
    size="small"
    :disabled="disableToolbar || props.disabled"
    :color="props.color"
    icon
    :class="{ 'v-btn--active': props.isActive && props.isActive() }"
    @click="props.action"
  >
    <VIcon :icon="getIcon(props.icon)" />
    <VTooltip :eager="false" activator="parent" location="top" :text="props.tooltip" />
    <slot></slot>
  </VBtn>
</template>
